<template>
  <CCardBody class="TableBalancerecurrentAddOns dataTable__body tableBalance__body p-0" v-if="viewMode.hiddenTable">
    <h4 class="font-weight-normal mb-2">
      {{ $t(`backoffice.manage.balance.tables.table-recurrentAddOns`) }}
    </h4>
    <hr v-if="viewMode.haslineNameTable" />
    <!-- {{ recurrentAddOns }} -->
    <CDataTable
      :key="`itemsDataTableRecurrentEmail`"
      v-if="recurrentNonCanceled.length"
      :fields="fields"
      :responsive="false"
      :items="recurrentNonCanceled"
      :table-filter="{ external: true, lazy: true }"
      items-per-page-select
      :loading="false"
      hover
    >
      <template #balanceRenewalPeriod>
        <td>
          <span>
            {{ $t('general.subscription.select.monthly') }}
          </span>
        </td>
      </template>
      <template #balance="{ item, index }">
        <td class="position-relative">
          <InputValueSubscription
            :item="item"
            :index="index"
            @toggle-inputValue="toggleInputValueSubscription"
            @save-LineBalance="addRecurring"
            @update-LineBalance="updateRecurring"
          />
          <TableAlert :payload="item" />
        </td>
      </template>
      <template #delete="{ item, index }">
        <td v-if="!item.addOnOrganizationStatus || item.addOnOrganizationStatus == 1" class="position-relative text-center" @click.stop>
          <CButton
            :data-cy="'deleteLine' + index"
            color="white"
            aria-label="delete"
            :key="item.id"
            title="delete"
            class="tableBalance__btn text-gray-600"
            @click.stop="toggleDelete(item)"
          >
            <CIcon name="trash" class="mx-1" size="custom-size" :height="12" viewBox="0 0 32 32" />
          </CButton>

          <transition name="fade" v-if="item._modalDelete">
            <div class="dataTable__popUp dataTable__popUp--right popUp" @click.stop>
              <div class="popUp__body shadow-sm">
                <ConfirmationDelete
                  :title="''"
                  :description="$t('backOffice.manage.balace.tables.table-one-shot.text-delete')"
                  @confirm="removeRecurring(item)"
                  @cancel="toggleDelete(item)"
                />
              </div>
            </div>
          </transition>
        </td>
        <td v-else class="text-center">
          {{ $t(`backoffice.manage.balance.tables.text.canceled`) }}
        </td>
      </template>
    </CDataTable>
    <div v-if="!recurrentAddOns.length > 0 || (hasRecurrentCanceled && !hasRecurrentActive)">
      <a class="text-gray-600 ml-3 selectCountry" @click="addLine">
        <template>
          <span class="font-3xl mr-1" style="line-height: 0.8em">+</span>
          <span>
            {{ $t(`backoffice.manage.balance.tables.components.add`) }}
          </span>
        </template>
      </a>
    </div>
  </CCardBody>
</template>

<script>
import ConfirmationDelete from '@/components/ConfirmationDelete'
import { actionsRecurring } from '../../mixins/ActionsTransactionsTable'

const fields = [
  { key: 'balanceRenewalPeriod', label: 'frequency' },
  { key: 'balance', label: 'value' },
  { key: 'delete', label: '', _classes: 'hidden text-center', _style: 'width:50px' },
]

export default {
  name: 'TableBalanceRecurrentEmail',
  components: {
    ConfirmationDelete,
    InputValueSubscription: () => import('./InputValueSubscription.vue'),
    TableAlert: () => import('./TableAlert.vue'),
  },

  mixins: [actionsRecurring],
  props: {
    recurrentAddOns: {
      type: Array,
      default: () => [],
    },
    channel: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      subscriptionCountry: null,
      fields,
    }
  },

  computed: {
    hasContriesInList() {
      return this.recurrentAddOns.map((item) => item.country)
    },

    hasRecurrentCanceled() {
      return this.recurrentAddOns.filter((el) => el.addOnOrganizationStatus == 3).length > 0
    },

    hasRecurrentActive() {
      return this.recurrentAddOns.filter((el) => el.addOnOrganizationStatus == 1).length > 0
    },

    recurrentNonCanceled() {
      return this.recurrentAddOns.filter((el) => el.addOnOrganizationStatus == 1)
    },

    viewMode() {
      // se state on e não há indices em recurrentAddOns
      if (this.recurrentAddOns.length == 0) {
        return { hiddenTable: true, haslineNameTable: true }
      }

      return { hiddenTable: true }
    },
  },

  methods: {
    // add item local
    addLine() {
      let data = {
        addOnOrganizationStatus: 1,
        balanceRenewalPeriod: 1,
        balance: 0,
        _channel: this.channel,
        _typeTable: 'recurrentAddOns',
        _tempId: Math.floor(Math.random() * 1000000),
        _currentBalanceTemp: 1,
        _modalChangeValue: false,
        _modalDelete: false,
        _message: {
          dismissCountDown: false,
          text: '',
          status: '',
        },
      }

      this.$store.commit('backOffice/ADD_LINE', { data, table: 'recurrentAddOns' })
    },
  },
}
</script>
